import * as ops from "./GUI2Operations";

export const FETCH_PREFERENCES = 'fieldsServlet?action=fetchPrefrences';
export const FIND_BY_ID = 'crud?operation=' + ops.OP_FIND_BY_ID;
export const FIND_BY_CODE = 'crud?operation=' + ops.OP_FIND_BY_BUSINESS_CODE;
export const FIND_REF_BY_ID = 'crud?operation=' + ops.OP_FIND_REF_BY_ID;
export const FIND_REFS_BY_IDS = 'crud?operation=' + ops.OP_FIND_REFS_BY_IDS;
export const FIND_REF_BY_CODE = 'crud?operation=' + ops.OP_FIND_REF_BY_CODE;
export const CREATE_NEW = 'crud?operation=' + ops.OP_NEW;
export const SAVE_AND_COMMIT = 'crud?operation=' + ops.OP_SAVE_AND_COMMIT;
export const REVISE = 'crud?operation=' + ops.OP_REVISE;
export const BULK_REVISE = 'crud?operation=' + ops.OP_BULK_REVISE;
export const SAVE_DRAFT = 'crud?operation=' + ops.OP_SAVE_DRAFT;
export const DUPLICATE = 'crud?operation=' + ops.OP_DUPLICATE;
export const NAVIGATE = 'crud?operation=' + ops.OP_NAVIGATE;
export const DELETE = 'crud?operation=' + ops.OP_DELETE;
export const BULK_DELETE = 'crud?operation=' + ops.OP_BULK_DELETE;
export const LIST_REFERENCES = 'crud?operation=' + ops.OP_LIST_REFERENCES;
export const TABULAR_LIST_PAGE = 'crud?operation=' + ops.OP_TABULAR_LIST_PAGE;
export const ListForSearchView = 'crud?operation=' + ops.OP_ListForSearchView;
export const LOGIN = 'login2?operation=' + ops.OP_Login;
export const NEW_UUID = 'login2?operation=' + ops.OP_NewUUID;
export const APPS_CONFIG = 'login2?operation=' + ops.OP_fetchAppsConfig;
export const LIST_ENTITIES = 'entities?action=listEntities';
export const SEARCH_ALL = 'crud?operation=' + ops.OP_SEARCH_ALL;
export const NEW_IDS = 'crud?operation=' + ops.OP_NEW_IDS;
export const APPROVE = 'crud?operation=' + ops.OP_APPROVE;
export const UPDATE_APPROVALS_AND_NOTIFICATIONS = 'crud?operation=' + ops.OP_UPDATE_APPROVALS_AND_NOTIFICATIONS;
export const List_TOP_APPROVALS_AND_NOTIFICATIONS = 'crud?operation=' + ops.OP_listTopNotificationsAndApprovals;
export const MarkAsReadTop5Notifications = 'crud?operation=' + ops.OP_markAsReadTop5Notifications;
export const PERFORM_POST_ACTION = "fieldsServlet?action=" + ops.OP_PERFORM_POST_ACTIONS;
export const LOGOUT = 'login2?operation='+ops.OP_Logout;
export const Change_Password = 'login2?operation='+ops.OP_Change_Password;
export const Find_Approval_Case_By_Id = 'crud?operation='+ops.OP_Find_Approval_Case_By_Id;
export const PERFORM_PreValidation = "fieldsServlet?action=" + ops.OP_PERFORM_Prevalidation;
export const PERFORM_Custom_action = "fieldsServlet?action=" + ops.OP_Run_Custom_Action;
export const PERFORM_Gui_Action = "fieldsServlet?action=" + ops.OP_PERFORM_GUI_Action;
export const Change_Capabilities = 'crud?operation=' + ops.OP_Change_Capabilities;
export const ListSimpleEntitiesMatchingRef = 'crud?operation=' + ops.OP_AllSimpleEntitiesMatchingRef;
export const ListPageMatching = 'crud?operation=' + ops.OP_List_Page_matching;
export const PERFORM_Grid_ACTION = "fieldsServlet?action=" + ops.OP_PERFORM_Grid_ACTIONS;
export const PERFORM_Suggestion = "fieldsServlet?action=" + ops.OP_Suggest;
export const FetchReportMetadata = "fieldsServlet?action=" + ops.OP_ReportMetadata;
export const SendEmailWithResult = "rpt2?action=" + ops.OP_sendEmailWithResult;
export const RunReport = "rpt2?action=" + ops.OP_RunReport;
export const OnReportQuestionsChanged = "rpt2?action=" + ops.OP_OnReportQuestionsChanged;
export const IsPrintReportPossible = "rpt2?action=" + ops.OP_isPrintReportPossible;
export const Search = 'entities?action=search';
export const FetchTermScreens = "entities?action=" + ops.OP_FetchTermConfigScreens;
export const FetchConfigEntriesScreens = "entities?action=" + ops.OP_FetchConfigEntriesScreens;
export const PerformCustomPostAction = "fieldsServlet?action=" + ops.OP_PerformCustomPostAction;
export const RunTooltip = "fieldsServlet?action=" + ops.OP_RunTooltip;
export const ReLogin = 'login2?operation=' + ops.OP_ReLogin;
export const ForgotPassword = 'login2?operation=' + ops.OP_Forgot;
export const ResetPasswordByToken = 'login2?operation=' + ops.OP_ResetPasswordByToken;
export const CalculateDimensions = 'login2?operation=' + ops.OP_CalculateDimensions;
export const FetchCharts = 'login2?operation=' + ops.OP_FetchDashBoardCharts;
export const FetchChartsMetadata = 'login2?operation=' + ops.OP_FetchChartsMetaData;
export const FetchAutoDashboardsAndReports = 'fieldsServlet?action=' + ops.OP_FetchAutoDashboardsAndReports;
export const FetchDashboardGroupItems = 'fieldsServlet?action=' + ops.OP_FetchDashboardGroupItems;
export const AddDiscussion = "fieldsServlet?action=" + ops.OP_AddDiscussion;
export const CalcGuiActionDefaults = "fieldsServlet?action=" + ops.OP_CalcGuiActionDefaults;
export const ExecuteTimedQuery = "crud?operation=" + ops.OP_ExeTimedQuery;
export const RunSQL = "crud?operation=" + ops.OP_runSQL;
export const ExportToExcel = "fieldsServlet?action=" + ops.OP_ExportToExcel;
export const UploadFileByDataURL = "fieldsServlet?action=" + ops.OP_uploadFileByDataURL;
export const PreparePGWLine = "fieldsServlet?action=" + ops.OP_preparePGWLine;
export const SignDocuments = "fieldsServlet?action=" + ops.OP_signDocuments;
export const SearchForHelpMsgs = "fieldsServlet?action=" + ops.OP_searchForHelpMsgs;
export const FetchDimsConfig = "fieldsServlet?action=" + ops.OP_fetchDimsConfig;
export const FetchWizardMetaData = "wizardservlet?action=" + ops.OP_WIZARD_METADATA;
export const OnWizardNextStep = "wizardservlet?action=" + ops.OP_WIZARD_NEXT_STEP;
export const ApplyWizardData = "wizardservlet?action=" + ops.OP_APPLY_WIZARD;
export const SaveWizardData = "wizardservlet?action=" + ops.OP_SAVE_WIZARD_DATA;
export const UpdateTaxAuthJson = "fieldsServlet?action=" + ops.OP_UPDATE_TAX_AUTHORITY_JSON;
export const FetchGUIThemes = "guiThemes.css";
export const CHECK_FOR_PENDING_GUI_ACTION_RESULT = "fieldsServlet?action=" + ops.CHECK_FOR_PENDING_GUI_ACTION_RESULT;
